module.exports = __webpack_public_path__ + "static/media/pic1.e067ebe4.jpg";